import { useState } from "react";
import {
  FaTimes,
  FaChevronLeft,
  FaChevronRight,
  FaCalendarAlt,
} from "react-icons/fa";

import gallery1 from "../Assets/images/gallery1.png";
import gallery2 from "../Assets/images/gallery2.jpeg";
import gallery3 from "../Assets/images/gallery3.jpg.jpeg";
import gallery4 from "../Assets/images/gallery4.jpg.jpeg";
import gallery5 from "../Assets/images/gallery5.jpg.jpeg";
import gallery6 from "../Assets/images/gallery6.png";
import gallery7 from "../Assets/images/gallery7.jpeg";
import gallery8 from "../Assets/images/gallery8.jpg.jpeg";
import gallery9 from "../Assets/images/gallery9.png";

const galleryData = [
  { id: 1, date: "05 Dec 2025", title: "Medical Help Camp", image: gallery1 },
  {
    id: 2,
    date: "12 Jan 2026",
    title: "Accident Relief Support",
    image: gallery2,
  },
  { id: 3, date: "20 Jan 2026", title: "Elder Care Program", image: gallery3 },
  {
    id: 4,
    date: "02 Feb 2026",
    title: "Child Medical Assistance",
    image: gallery4,
  },
  { id: 5, date: "10 Feb 2026", title: "Livelihood Support", image: gallery5 },
  {
    id: 6,
    date: "18 Feb 2026",
    title: "Community Food Drive",
    image: gallery6,
  },
  {
    id: 7,
    date: "25 Feb 2026",
    title: "Emergency Hospital Visit",
    image: gallery7,
  },
  { id: 8, date: "03 Mar 2026", title: "Village Health Camp", image: gallery8 },
  { id: 9, date: "12 Mar 2026", title: "Senior Citizen Care", image: gallery9 },
];

const Gallery = () => {
  const [lightbox, setLightbox] = useState(null); // index or null

  const openLightbox = (index) => setLightbox(index);
  const closeLightbox = () => setLightbox(null);
  const prev = () =>
    setLightbox((i) => (i - 1 + galleryData.length) % galleryData.length);
  const next = () => setLightbox((i) => (i + 1) % galleryData.length);

  // Close on backdrop click
  const handleBackdrop = (e) => {
    if (e.target === e.currentTarget) closeLightbox();
  };

  // Keyboard nav
  const handleKey = (e) => {
    if (e.key === "ArrowLeft") prev();
    if (e.key === "ArrowRight") next();
    if (e.key === "Escape") closeLightbox();
  };

  return (
    <div className="gallery-page" onKeyDown={handleKey} tabIndex={-1}>
      {/* ── PAGE HERO ── */}
      <section className="about-hero">
        <div className="about-hero-bg" />
        <div className="container">
          <div className="about-hero-inner">
            <p className="about-eyebrow">Our Moments</p>
            <h1>
              Foundation <span>Gallery</span>
            </h1>
            <p className="about-hero-sub">
              Explore glimpses of our initiatives, events, and the impact we
              create through meaningful actions and community support.
            </p>
          </div>
        </div>
      </section>

      {/* ── GALLERY SECTION ── */}
      <section className="gallery-section">
        <div className="container">
          <div className="gallery-section-header">
            <p className="gallery-eyebrow">Photo Gallery</p>
            <h2>
              Our Work in <span>Pictures</span>
            </h2>
            <p className="gallery-subtext">
              A visual record of the lives we've touched and the communities
              we've served.
            </p>
          </div>

          <div className="gallery-grid">
            {galleryData.map((item, index) => (
              <div
                className="gallery-card"
                key={item.id}
                onClick={() => openLightbox(index)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === "Enter" && openLightbox(index)}
                aria-label={`View ${item.title}`}
              >
                <div
                  className="gallery-img"
                  style={{ backgroundImage: `url(${item.image})` }}
                >
                  <div className="gallery-overlay">
                    <span className="gallery-view-label">View Photo</span>
                  </div>
                  <span className="gallery-date-badge">
                    <FaCalendarAlt /> {item.date}
                  </span>
                </div>
                <div className="gallery-card-footer">
                  <h5>{item.title}</h5>
                  <span className="gallery-card-num">
                    #{String(item.id).padStart(2, "0")}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── LIGHTBOX ── */}
      {lightbox !== null && (
        <div className="lightbox-backdrop" onClick={handleBackdrop}>
          <button
            className="lightbox-close"
            onClick={closeLightbox}
            aria-label="Close"
          >
            <FaTimes />
          </button>

          <button
            className="lightbox-nav lightbox-prev"
            onClick={prev}
            aria-label="Previous"
          >
            <FaChevronLeft />
          </button>

          <div className="lightbox-content">
            <img
              src={galleryData[lightbox].image}
              alt={galleryData[lightbox].title}
            />
            <div className="lightbox-caption">
              <span className="lightbox-caption-date">
                <FaCalendarAlt /> {galleryData[lightbox].date}
              </span>
              <h4>{galleryData[lightbox].title}</h4>
              <span className="lightbox-counter">
                {lightbox + 1} / {galleryData.length}
              </span>
            </div>
          </div>

          <button
            className="lightbox-nav lightbox-next"
            onClick={next}
            aria-label="Next"
          >
            <FaChevronRight />
          </button>
        </div>
      )}
    </div>
  );
};

export default Gallery;
